<div *ngIf="loadingService.loading$ | async" class="container">
  <mat-spinner></mat-spinner>
</div>
